<template>
  <HiDialog v-model="isOpen" @submit="submit" title="Edit Budget" width="300">
    <div class="pt-8 flex-row-base">
      <v-text-field
        v-model="value[0]"
        label="Min"
        class="flex-grow-1"
        suffix="MIL"
        type="number"
      ></v-text-field
      ><span style="width:50px"></span>
      <v-text-field
        v-model="value[1]"
        label="Max"
        suffix="MIL"
        class="flex-grow-1"
        type="number"
      ></v-text-field>
    </div>
  </HiDialog>
</template>

<script>
import HiDialog from "@/components/HiDialog";
import { collections, DocHelper } from "@/db";
export default {
  components: {
    HiDialog
  },
  props: {
    collection: {
      type: String,
      default: "leads"
    },
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      value: [],
      isOpen: false
    };
  },
  methods: {
    async open() {
      this.isOpen = true;
      this.values = [];
      this.values = [];
      const doc = await collections.leads.doc(this.id).get();

      const data = doc.data();
      if (data.budget) {
        this.value = data.budget;
      } else {
        this.value = [];
      }
    },
    async submit() {
      const helper = new DocHelper("leads", this.id);
      await helper.update(
        "budget",
        this.value.map(x => Number(x))
      );
      // await collections.leads
      //   .doc(this.id)
      //   .update({ budget: this.value.map(x => Number(x)) });
      this.isOpen = false;
    }
  }
};
</script>

<style scoped>
input[type="number"] {
  -moz-appearance: textfield;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>
